var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGeoVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_Vector-f") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_Vector-f",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/24px/Content/add-box-Copy-4",
    transform: "translate(2.181818, 2.727273)",
    fill: "#434343"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0909091,0.542797234 C19.0909091,0.243018599 18.8451488,-3.98544833e-14 18.5514704,-3.98544833e-14 L14.9646319,-3.98544833e-14 L14.9646319,1.38398915 L4.12627718,1.38398915 L4.12627718,-3.98544833e-14 L0.539438681,-3.98544833e-14 C0.241514924,-3.98544833e-14 0,0.247290442 0,0.542797234 L0,4.15196744 L1.37542573,4.15196744 L1.37542573,14.3934871 L0,14.3934871 L0,18.0026573 C0,18.3024359 0.245760335,18.5454545 0.539438681,18.5454545 L4.12627718,18.5454545 L4.12627718,17.1614654 L14.9646319,17.1614654 L14.9646319,18.5454545 L18.5514704,18.5454545 C18.8493942,18.5454545 19.0909091,18.2981641 19.0909091,18.0026573 L19.0909091,14.3934871 L17.7154834,14.3934871 L17.7154834,4.15196744 L19.0909091,4.15196744 L19.0909091,0.542797234 Z M2.72727273,1.09090909 L2.72727273,2.72727273 L1.09090909,2.72727273 L1.09090909,1.09090909 L2.72727273,1.09090909 Z M1.09090909,17.4545455 L1.09090909,15.8181818 L2.72727273,15.8181818 L2.72727273,17.4545455 L1.09090909,17.4545455 Z M4.10747148,15.8181818 L4.10747148,14.4255319 L2.72727273,14.4255319 L2.72727273,4.11992263 L4.10747148,4.11992263 L4.10747148,2.72727273 L14.9834376,2.72727273 L14.9834376,4.11992263 L16.3636364,4.11992263 L16.3636364,14.4255319 L14.9834376,14.4255319 L14.9834376,15.8181818 L4.10747148,15.8181818 Z M16.3636364,17.4545455 L16.3636364,15.8181818 L18,15.8181818 L18,17.4545455 L16.3636364,17.4545455 Z M16.3636364,1.09090909 L18,1.09090909 L18,2.72727273 L16.3636364,2.72727273 L16.3636364,1.09090909 Z",
    id: "-\\u21B3Color"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    points: "7.09090909 14.1818182 10.0331773 11.3544937 14.1818182 11.3544937 7.09090909 4.36363636"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGeoVector);
export default __webpack_public_path__ + "static/media/ic_geo-vector.dd31959f88de15b94fce44dda5bc9251.svg";
export { ForwardRef as ReactComponent };